import React, { useEffect, Fragment, useState } from 'react';
import { Button, Row, Col, Form, message } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { useTranslate } from 'Translate';

const _ = require('lodash');

function removeUnderscoreAndCapitalize(value) {
  if(value) return value.split("_").map(item => `${item.slice(0, 1).toUpperCase()}${item.slice(1)}`).join(' ')
  return value
}

export default (props) => {
  const { id, data, meta, addStockTemplate, editStockTemplate, reloadApi, mode, allowedEdit } = props;
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const i18n = useTranslate();
    const { t } = i18n;

  const formFields = [
    {
      name: 'code',
      label: t("General.code"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'desc',
      label: t("General.desc"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      type: 'select',
      label: t("Inventory.st_type"),
      name: 'stock_template_type',
      twocol: false,
      options: meta?.stock_template_types?.map((x) => ({ label: removeUnderscoreAndCapitalize(x), value: x })),
      req: true,
      placeholder: t("General.please_select"),
      reqmessage: t("Inventory.st_type_req"),
      colWidth: '0 1 50%',
      static: !allowedEdit
    },
    {
      name: 'order_type_group',
      label: t("Inventory.recipe"),
      req: false,
      placeholder: t("General.please_select"),
      type: 'select',
      class: 'default-select',
      options: meta?.order_type_groups?.map(y => ({ label: `${y.code} ${y.desc}`, value: y.id })),
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
    },
  ];

  useEffect(() => {
    if (data && 'id' in data && mode !== 'add') {
      setValue('code', data?.code);
      setValue('desc', data?.desc);
      setValue('stock_template_type', data?.stock_template_type ? { label: removeUnderscoreAndCapitalize(data.stock_template_type), value: data.stock_template_type } : '');
      setValue('order_type_group', data?.order_type_group_id ? {label: `${data?.order_type_group_code} ${data?.order_type_group_desc}`, value: data.order_type_group_id} : "");
    }
  }, [data]);

  const onFinishAdd = async (val) => {
    props.setLoading(true);

    const payload = {
      ...val,
      stock_template_type: val?.stock_template_type?.value,
      order_type_group_id: val?.order_type_group?.value,
    }

    await addStockTemplate(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.create_stock_template"));
        reloadApi(res.data.data);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  const onFinish = async (val) => {
    if(mode === 'add') {
      return onFinishAdd(val);
    }
    props.setLoading(true);
    const payload = {
      ...val,
      stock_template_type: val?.stock_template_type?.value,
      order_type_group_id: val?.order_type_group?.value,
      stock_template_id: id,
    }

    await editStockTemplate(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_stock_template"));
        setTimeout(() => reloadApi(res.data.data), 250);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}